export default function initFeedSlider($) {
  var selected_athlete_index = 0;
  var select_athlete_debounce = null;
  function selectFeaturedAthlete(index) {
    var num_athletes = $('.feed-sliders .feed-slider').length;

    if (index < 0) {
      index = num_athletes - 1;
    }

    if (index >= num_athletes) {
      index = 0;
    }

    selected_athlete_index = index;

    $('.feed-sliders').css('transform', 'translateX(' + index * (-100 / num_athletes) + '%)');

    // This is weird, but get rid of any extraneous pixels on the side of the athletes, but make sure that
    // they remain visible during scroll
    $('.feed-slider').css('visibility', 'visible');
    clearTimeout(select_athlete_debounce);
    select_athlete_debounce = setTimeout(function() {
      $('.feed-slider').css('visibility', 'hidden');
      $('.feed-slider').eq(index).css('visibility', 'visible');
    }, 500);


    $('.feed-slider-dots .feed-slider-dot').removeClass('active');
    $('.feed-slider-dots .feed-slider-dot').eq(index).addClass('active');
  }

  $(document).on('click', '.feed-slider-next', function(e) {
    selectFeaturedAthlete(selected_athlete_index + 1);
  });

  $(document).on('click', '.feed-slider-prev', function(e) {
    selectFeaturedAthlete(selected_athlete_index - 1);
  });

  // Left and right keys
  $(document).on('keydown', function(e) {
    if (e.keyCode === 37) {
      selectFeaturedAthlete(selected_athlete_index - 1);
    }

    if (e.keyCode === 39) {
      selectFeaturedAthlete(selected_athlete_index + 1);
    }
  });

  // Swipe
  if ($('.feed-sliders-main').length > 0) {
    var featured_athlete_hammer = new Hammer($('.feed-sliders-main')[0], {});
    featured_athlete_hammer.on('swipeleft', function(ev) {
      selectFeaturedAthlete(selected_athlete_index + 1)
    });
    featured_athlete_hammer.on('swiperight', function(ev) {
      selectFeaturedAthlete(selected_athlete_index - 1);
    });

    $(document).on('click', '.feed-slider-dots .feed-slider-dot', function(e) {
      selectFeaturedAthlete($(this).index());
    });

    selectFeaturedAthlete(selected_athlete_index);
  }

}
